import { UpcomingMatchesSchema } from '@/views/sports/UpcomingMatches/styles/UpcomingMatches.styles';

export const upcomingMatchesStyles: UpcomingMatchesSchema = {
  pageHeader: {
    fontSize: '22px',
    fontWeight: 'bold',
    fontFamily: 'heading',
    color: 'beta.300',
    pb: ['0', null, '3'],
    textTransform: 'uppercase',
    mx: ['3', null, '0'],
    pt: ['3', null, '0'],
  },
  pageButtonWellWrapperOverride: {
    h: '28px',
    w: 'full',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    lineHeight: 'normal',
    bgGradient: 'linear(to-b, beta.200, beta.400)',
    textTransform: 'uppercase',
    boxShadow: '0px 1px 3px 0px rgba(0, 0, 0, 0.25)',
    fontFamily: 'accent',
    borderRadius: 'base',
    sx: {
      '&&': {
        button: {
          color: 'blackAlpha.800',
          textShadow: '0px 1px 0px rgba(255, 255, 255, 0.25)',
        },
        fontWeight: 'bold',
        fontSize: '11px',
        color: 'blackAlpha.800',
        svg: {
          bg: 'blackAlpha.700',
          p: '0.5',
          color: 'beta.200',
          borderRadius: 'sm',
        },
      },
    },
  },
  stackWrapper: {
    color: 'white',
    mt: ['-1', null, '0', '-2'],
    p: '0',
  },
  hStackWrapper: {
    justifyContent: 'flex-end',
  },
  sortByText: {
    fontSize: '2xs',
    fontWeight: 'extrabold',
    textTransform: 'uppercase',
    color: 'white',
    fontFamily: 'accent',
  },
  scrollButtonGroup: {
    bg: 'none',
    boxShadow: 'none',
    variant: 'filter',
  },
  flexRenderSortingMobile: {
    justify: 'flex-end',
  },
  loadingSkeletonText: {
    my: '4',
    noOfLines: 2,
    spacing: '4',
    skeletonHeight: '2',
  },
  mainStackWrapper: {
    spacing: '4',
  },
  mainStackInner: {
    spacing: '4',
    sx: {
      '> div[class*="chakra-stack"]:first-child': {
        mt: '2',
      },
      'a[data-testid*="pageButton-button"]': {
        h: '28px',
        w: 'full',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        lineHeight: 'normal',
        bgGradient:
          'linear(to-b, rgba(255, 255, 255, 0.12), rgba(255, 255, 255, 0.05))',
        textTransform: 'uppercase',
        boxShadow: '0px 2px 5px 0px rgba(0, 0, 0, 0.25)',
        fontFamily: 'accent',
        borderRadius: 'base',
        color: 'white',
        border: '2px solid',
        borderColor: 'beta.300',
        svg: {
          bg: 'beta.300',
          p: '0.5',
          color: 'alpha.400',
          borderRadius: 'sm',
        },
        sx: {
          '&&': {
            fontWeight: 'bold',
            fontSize: '11px',
          },
        },
      },
    },
  },
  heading: {
    alignItems: 'center',
    display: 'flex',
    fontSize: 'lg',
    gap: '1',
    textShadow: '0px 2px 4px rgba(0, 0, 0, 0.25)',
    fontFamily: 'heading',
    fontWeight: 'bold',
    textTransform: 'uppercase',
    color: 'beta.300',
  },
  headingIcon: {
    color: 'beta.300',
    sx: {},
  },
  propositionButton: {
    variant: 'odds',
    flex: '1',
    height: '38px',
    display: 'initial',
  },
  boxSportWrapper: {
    display: 'none',
  },
  buttonSport: {
    pr: '28px',
    sx: {
      '&:after': {
        content: '""',
        position: 'absolute',
        display: 'block',
        border: '1px',
        borderColor: 'white',
        boxSize: '2.5',
        top: '7px',
        right: '2.5',
        borderRadius: 'full',
        pr: '2',
      },
      ':hover': {
        '&:after': {
          borderColor: 'whiteAlpha.700',
        },
      },
    },
  },
  buttonAllSports: {
    _active: {
      bg: 'beta.400',
      color: 'blackAlpha.800',
      border: 'none',
      '&:after': {
        display: 'none',
      },
    },
  },
  segmentedButtonSortByTime: {
    h: '6',
    color: 'white',
    fontSize: '2xs',
    textTransform: 'uppercase',
    fontWeight: 'bold',
    borderRadius: 'base',
    bgGradient: 'unset',
    _hover: {
      color: 'beta.300',
    },
    _before: {
      display: 'none',
    },
    _active: {
      bgGradient: 'linear(to-b, beta.300, beta.400)',
      color: 'blackAlpha.800',
    },
  },
  segmentedButtonSortBySport: {
    h: '6',
    color: 'white',
    fontWeight: 'bold',
    fontSize: '2xs',
    textTransform: 'uppercase',
    borderRadius: 'base',
    bgGradient: 'unset',
    _hover: {
      color: 'beta.300',
    },
    _before: {
      display: 'none',
    },
    _active: {
      bgGradient: 'linear(to-b, beta.300, beta.400)',
      color: 'blackAlpha.800',
    },
  },
};
